/* eslint-disable node/prefer-global/process */
import { decodeJwt } from '@autobid/nuxt-auth/src/utils/decodeJwt'
import { getError } from '@autobid/strapi-integration/utils/getError'
import { checkUserPermission } from '@autobid/ui/composables/useCheckUserPermission'
import { BEAMER_BID_ACCESS_KEY } from '@autobid/ui/constants/BEAMER_BID_ACCESS_KEY'

export default defineNuxtRouteMiddleware(async (to) => {
  if (process.client) {
    return
  }

  const auctionId = to.params.auctionId
  if (typeof auctionId !== 'string' || Number.isNaN(Number(auctionId.toString()))) {
    throw createError({
      statusCode: 404,
    })
  }

  const APP_ID = useRuntimeConfig().public.APP_ID
  const { data: sessionData } = useAuth()
  const cookie = useCookie<boolean>(BEAMER_BID_ACCESS_KEY)
  const { $trpc } = useNuxtApp()

  if (!sessionData.value?.accessToken) {
    throw createError({ statusCode: 401 })
  }

  const tokenData = decodeJwt(sessionData.value.accessToken.split(' ')[1])
  const hash = tokenData.access.hash

  try {
    const permissionsMap = await $trpc.cerber.getPermissions.query({ hash })
    if (!permissionsMap) {
      throw createError({ statusCode: 500, statusMessage: 'Unable to get permissions' })
    }

    const REQUIRED_PERM = 'netlive-beamer'
    const BID_PERM = 'saalbieter'

    const hasAccess = checkUserPermission({
      appId: APP_ID,
      permissionName: REQUIRED_PERM,
      permissionsMap,
      tokenData,
    })

    if (!hasAccess) {
      throw createError({
        statusCode: 403,
      })
    }

    const hasBidAccess = checkUserPermission({
      appId: APP_ID,
      permissionName: BID_PERM,
      permissionsMap,
      tokenData,
    })
    cookie.value = !!hasBidAccess
  }
  catch (error) {
    const { message, code } = getError(error)

    throw createError({ statusCode: code, statusMessage: message })
  }
})
